import { render, staticRenderFns } from "./Block2.vue?vue&type=template&id=62a928c5&scoped=true"
import script from "./Block2.vue?vue&type=script&lang=js"
export * from "./Block2.vue?vue&type=script&lang=js"
import style0 from "./Block2.vue?vue&type=style&index=0&id=62a928c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a928c5",
  null
  
)

export default component.exports